import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Basket } from '../types/basket.type';
import { CreateBasketRequestDTO } from '../types/dtos/create-basket.dto';
import { ADMIN_BASKETS_API_PATHS } from '../constants/baskets-api-paths.constants';

type UseCreateBasketResult = {
  createBasket: (data: CreateBasketRequestDTO) => Promise<Basket | null>;
  isSubmitting: boolean;
};

export function useCreateBasket(): UseCreateBasketResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createBasket = async (data: CreateBasketRequestDTO): Promise<Basket | null> => {
    setIsSubmitting(true);

    try {
      const basket = await HttpClient.post<Basket, CreateBasketRequestDTO>(ADMIN_BASKETS_API_PATHS.CREATE_BASKET, data);

      enqueueSnackbar('Le panier a été créé', { variant: 'success' });
      return basket;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création du panier'),
        {
          variant: 'error',
        }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { createBasket, isSubmitting };
}
